<template>
  <div>
    <div class="title">
      {{ _.delete_all_filtered }} {{ _[massdel.model] }}
      <span @click="closeModal()"><font-awesome-icon :icon="['fas', 'times']" /></span>
    </div>
    <div class="content">
      <div class="confirm" v-if="!sure">
        <b>{{ _['sure_to_delete_' + massdel.model] }}</b>
        <div class="control">
          <span class="button delete" @click="sure = true">{{ _.yes_delete }}</span>
          <span class="button cancel" @click="closeModal()">{{ _.no_cancel }}</span>
        </div>
      </div>
      <div class="confirm absolutely" v-if="sure">
        <b>{{ _['sure_absolutely'] }}</b>
        <div class="control">
          <span class="button delete" @click="deleteItems()">{{ _.yes_delete }}</span>
          <span class="button cancel" @click="closeModal()">{{ _.no_cancel }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  data() {
    return {
      sure: false,
    }
  },
  computed: {
    ...mapGetters(['massdel']),
  },
  methods: {
    ...mapMutations(['closeModal']),
    handleKeyUp(event) {
      if (event.keyCode === 13) {
        this.deleteItems(this.massdel.ids);
      }
    }
  },
  created() {
    window.addEventListener('keyup', this.handleKeyUp);
  },
  destroyed() {
    window.removeEventListener('keyup', this.handleKeyUp);
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/variables.scss';
.modal {
  > div {
    > div {
      display: grid;
      grid-template-rows: 40px 1fr;
      grid-template-columns: 1fr;
      height: 100%;
      > .title {
        grid-area: 1/1/2/2;
        background: $primary-color;
        color: #ffffff;
        padding: 12px;
        font-weight: bold;
        > span {
          float: right;
          margin-right: 4px;
          opacity: .4;
          &:hover {
            opacity: 1;
          }
        }
        .svg-inline--fa {
          cursor: pointer;
        }
      }
      > .content {
        grid-area: 2/1/3/2;
        background: #ffffff;
        overflow-y: scroll;
        position: relative;
        > div {
          &.confirm {
            background: lighten($error-color, 70%);
            color: $error-color;
            border-bottom: 1px solid lighten($error-color, 60%);
            line-height: 28px;
            padding: 12px;
            > .control {
              float: right;
              > .button {
                padding: 8px 12px;
                cursor: pointer;
                font-weight: bold;
                &.delete {
                  border-radius: 4px 0 0 4px;
                  border: 1px solid $error-color;
                  background: $error-color;
                  color: #ffffff;
                }
                &.cancel {
                  border-radius: 0 4px 4px 0;
                  border: 1px solid lighten($error-color, 60%);
                }
              }
            }
          }
          &.confirm.absolutely {
            background: $error-color;
            color: #ffffff;
            border-bottom: 1px solid $error-color;
            line-height: 28px;
            padding: 12px;
            > .control {
              float: right;
              > .button {
                padding: 8px 12px;
                cursor: pointer;
                font-weight: bold;
                &.delete {
                  border-radius: 4px 0 0 4px;
                  border: 1px solid #ffffff;
                  background: #ffffff;
                  color: $error-color;
                }
                &.cancel {
                  border-radius: 0 4px 4px 0;
                  border: 1px solid #ffffff;
                  background: lighten($error-color, 70%);
                  color: $error-color;
                }
              }
            }
          }
          > div {
            position: relative;
          }
        }
      }

    }
  }
}

</style>